// Define shade numbers available in Tailwind
export type ShadeNumber =
  | 50
  | 100
  | 200
  | 300
  | 400
  | 500
  | 600
  | 700
  | 800
  | 900
  | 950;

// Define a type for color palettes with all shade numbers
export type ColorPalette = Record<ShadeNumber, string>;

// Define the tailwind color map type
export type TailwindColorMap = {
  ok: string;
  info: string;
  warning: string;
  critical: string;
  primary: ColorPalette;
  gray: ColorPalette;
};

export const tailwindColorMap: TailwindColorMap = {
  ok: 'rgb(54, 199, 153)',
  info: 'rgb(134, 221, 194)',
  warning: 'rgb(252, 198, 89)',
  critical: 'rgb(255, 104, 104)',

  // Gauge states
  primary: {
    50: 'rgb(237, 252, 246)',
    100: 'rgb(211, 248, 231)',
    200: 'rgb(171, 239, 211)',
    300: 'rgb(117, 224, 187)',
    400: 'rgb(54, 199, 153)',
    500: 'rgb(25, 176, 133)',
    600: 'rgb(13, 142, 108)',
    700: 'rgb(10, 114, 89)',
    800: 'rgb(11, 90, 72)',
    900: 'rgb(10, 74, 60)',
    950: 'rgb(4, 42, 35)',
  },
  gray: {
    50: 'rgb(249, 250, 251)',
    100: 'rgb(243, 244, 246)',
    200: 'rgb(229, 231, 235)',
    300: 'rgb(209, 213, 219)',
    400: 'rgb(156, 163, 175)',
    500: 'rgb(107, 114, 128)',
    600: 'rgb(75, 85, 99)',
    700: 'rgb(55, 65, 81)',
    800: 'rgb(31, 41, 55)',
    900: 'rgb(17, 24, 39)',
    950: 'rgb(3, 7, 18)',
  },
};
